import {BrowserRouter, useRoutes} from 'react-router-dom';
import {
  keepPreviousData,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import {lazy} from 'react';
import {AuthProvider} from '@/auth/AuthProvider';
import {PATHS} from '@/routes/paths';
import {UserFeaturesProvider} from '@/core/feature-flags/UserFeaturesProvider';
import Toaster from '@/toast/Toaster';
import {routes} from './routes/routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      placeholderData: keepPreviousData,
    },
  },
});

const MainLayout = lazy(() => import('./layouts/MainLayout'));
const LoginPage = lazy(() => import('./pages/auth/LoginPage'));
const LogoutPage = lazy(() => import('./pages/auth/LogoutPage'));

const AppRoutes = () => {
  const element = useRoutes([
    {
      path: PATHS.login.pattern,
      element: <LoginPage />,
    },
    {
      path: PATHS.logout.pattern,
      element: <LogoutPage />,
    },
    {
      element: <MainLayout />,
      children: routes,
    },
  ]);

  return element;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <UserFeaturesProvider>
            <AppRoutes />
            <Toaster />
          </UserFeaturesProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
